export const getSectionTooltipMessage = (item) =>
  item.tooltipDetail || item.description || "";
